<template>
    <div></div>
</template>

<script>
    /*
     * Developer Notes
     *
     * This page appears within an iframe inside /src/components/Checkout/PaymentDetails.vue
     * and is loaded after the user fails to verify their account details via 3D Secure.
     *
     * This page simply posts a message to the parent window which keeps the user on the
     * payment details page, so that they can try again.
     */
    export default {
        name: 'appointment-error',

        created() {
            window.parent.postMessage('appointment.error', `${window.location.protocol}//${window.location.host}`);
        },
    }
</script>
